import { ConversationDto, ConversationState } from "../dto/conversation";

/// Template-only per Pending (outbound/in attesa) e Inactive (24h scadute).
export function isTemplateOnly(convo: ConversationDto): boolean {
  return (
    convo.state === ConversationState.Pending ||
    convo.state === ConversationState.Inactive
  );
}

/// Input completamente disabilitato per conversazioni chiuse.
export function isInputDisabled(convo: ConversationDto): boolean {
  return convo.state === ConversationState.Closed;
}
